export default __webpack_public_path__ + "static/media/mitsubishi-logo-small.0ea70ece.png";